import { useState, useCallback } from 'react'
import customAxios from 'routes/Pages/util/Api'
import authHeader from 'services/auth/jwt/auth-header'

const ALL_KEY = 'ALL'
const cache = new Map() // key -> Promise of options[]

const toOptions = (data) =>
    (Array.isArray(data) ? data : data ? [data] : []).map((item) => ({
        value: item.contractUniqueID,
        label: `${item.contractUniqueID} ${item.wH_NumberName}`,
    }))

export function useGetWhDetails() {
    const [fullSPDetails, setFullSPDetails] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    const fetchSPDetails = useCallback(async (contractUniqueID) => {
        const key = contractUniqueID || ALL_KEY

        if (!cache.has(key)) {
            const request = customAxios
                .get('/Ops/GetContracts', {
                    headers: authHeader(),
                    params: contractUniqueID
                        ? { flagActive: 1, contractUniqueID }
                        : { flagActive: 1 },
                })
                .then(({ data }) => toOptions(data))
                .catch((err) => {
                    cache.delete(key) // don't cache failures
                    throw err
                })
            cache.set(key, request)
        }

        setIsLoading(true)
        setError(null)
        try {
            const options = await cache.get(key)
            setFullSPDetails(options)
            return options
        } catch (err) {
            setError(err)
            return []
        } finally {
            setIsLoading(false)
        }
    }, [])

    return { fullSPDetails, isLoading, error, fetchSPDetails }
}